import Categories from '../components/Filters/Categories';
import sortBy from '../components/Filters/SortBy';
import Orientation from '../components/Filters/Orientation';
import Color from '../components/Filters/Color';

export const FILTERS_MAP = [
  {
    name: 'catogories',
    component: Categories,
  },
  {
    name: 'sortBy',
    component: sortBy,
  },
  {
    name: 'orientation',
    component: Orientation,
  },
  {
    name: 'color',
    component: Color,
  },
];

export const FILTERS_SET = ['catogories', 'sortBy', 'orientation', 'color'];
